// extracted by mini-css-extract-plugin
module.exports = {"timestamp":"Timestamp-module__timestamp___37pni"};